// `/businesses/new` — dedicated create-business route (US-045 / US-105).
//
// The list page also embeds `<CreateBusinessForm>` in a modal; this route
// gives the FTU checklist + deep-links a stable URL to land on.

import { createRoute, useNavigate } from '@tanstack/react-router';

import { CreateBusinessForm } from '@/features/businesses/CreateBusinessForm';

import { Route as BusinessesLayoutRoute } from './__layout';

export const Route = createRoute({
  getParentRoute: () => BusinessesLayoutRoute,
  path: 'new',
  component: BusinessesNew,
});

function BusinessesNew() {
  const navigate = useNavigate();
  return (
    <section data-route="_authed/businesses/new" className="flex flex-col gap-4">
      <CreateBusinessForm
        onCreated={(id) => {
          void navigate({ to: '/businesses/$id', params: { id } });
        }}
        onCancel={() => {
          void navigate({ to: '/businesses' });
        }}
      />
    </section>
  );
}
